import VideoPreviewDisplay from './VideoPreviewDisplay.vue'
export default VideoPreviewDisplay

const minimumStingerDelay = 500
export { minimumStingerDelay }